import { render, staticRenderFns } from "./VergelijkingspuntList.vue?vue&type=template&id=1698e478"
import script from "./VergelijkingspuntList.vue?vue&type=script&lang=js"
export * from "./VergelijkingspuntList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports